import React, { useEffect, useState } from "react";
import { loginUsingFB } from "../../utility/facebookProvider";
import { httpPost, httpGet, httpPut } from "../../utility/requestHelper";
import { HTTP_CODES, VERTICALS } from "../../constants/app-constant";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { TOPICS } from "../../constants/route-constants";
import { useSelector, useDispatch } from "react-redux";
import { UserDropdown } from "../Shared/UserDropdown";
import { FacebookIcon } from "../Icons/icons.component";
import Loader from "../Shared/Loader";
import SocialIcon from "../NewsAndAnalysis/SocialIcon";
import { fetchSocialEntityDetails } from "../../actions/entity-action";
import { Button } from "../Shared/FormElements/Button";

export default function SocialConnect({
  history,
  setAddTopicStep,
  setEditData,
  pageIds,
  setPageIds,
}) {
  const dispatch = useDispatch();
  const [isPagesLoading, setIsPagesLoading] = useState(false);
  const [pages, setPages] = useState([]);
  const [isTopicAdditionIsProgress, setIsTopicAdditionInProgress] = useState(
    false
  );
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  useEffect(() => {
    getTopicPages();
    callPageApi();
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_FB_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v7.0",
      });
      window.FB.AppEvents.logPageView();
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const authoriseAccount = () => {
    loginUsingFB()
      .then((token) => {
        if (token) {
          setIsPagesLoading(true);
          setPages([]);
          httpPost(
            `${unifiedEnvConfig.SOCIAL_ACCOUNTS_AUTHORIZE}?client_id=${selectedClient.id}`,
            {
              token: token,
            }
          ).finally(() => {
            setIsPagesLoading(false);
            callPageApi();
          });
        } else {
          // TODO: handle else part
        }
      })
      .catch((e) => console.log(e));
  };

  const callPageApi = () => {
    setIsPagesLoading(true);
    httpGet(
      `${unifiedEnvConfig.SOCIAL_ACCOUNTS}?client_id=${selectedClient.id}`
    )
      .then((response) => {
        if (response && response.data && response.data.data) {
          setPages(response.data.data);
        }
      })
      .catch((e) => e)
      .finally(() => setIsPagesLoading(false));
  };

  const getCheckboxValue = (e) => {
    let pageIdarray = pageIds;
    if (!e.target.checked) {
      pageIdarray = pageIdarray.filter((item) => item !== e.target.value);
      setPageIds(pageIdarray);
    } else {
      setPageIds([...pageIds, e.target.value]);
    }
  };

  const getTopicPages = () => {
    const topicData = localStorage.getItem("topicData");
    const data = JSON.parse(topicData);
    const { editKey, id } = data || {};
    if (id) {
      httpGet(
        `${unifiedEnvConfig.FETCH_ONE_TOPIC}/${id}?client_id=${selectedClient.id}`
      )
        .then((response) => {
          if (response && response.data) {
            setPageIds(response.data.data.page_ids);
          }
        })
        .catch((e) => e);
    }
  };

  const addTopic = () => {
    setIsTopicAdditionInProgress(true);
    const topicData = localStorage.getItem("topicData");
    const data = JSON.parse(topicData);
    const { editKey, id } = data || {};
    /* Presence of id ensures that this is the edit call.*/
    if (id && editKey) {
      const {
        topicname,
        and_contains,
        or_contains,
        not_contains,
        hashtags,
        category,
      } = data;
      httpPut(
        `${unifiedEnvConfig.ADD_TOPIC}/${id}?client_id=${selectedClient.id}`,
        {
          topic_name: topicname,
          and_contains: and_contains,
          or_contains: or_contains,
          not_contains: not_contains,
          type: 1,
          page_ids: pageIds,
          hashtags: hashtags,
          category: category,
        }
      )
        .then(({ status }) => {
          if (status === HTTP_CODES.SUCCESS) {
            localStorage.clear();
            setAddTopicStep(-1);
            dispatch(fetchSocialEntityDetails(selectedClient.id));
          }
        })
        .catch((e) => e)
        .finally(() => {
          setEditData(null);
          setIsTopicAdditionInProgress(false);
        });
    } else if (data) {
      if (!selectedClient.id) {
        // some error message to be displayed.
        return;
      }
      const {
        topicname,
        and_contains,
        or_contains,
        not_contains,
        hashtags,
        category,
      } = data;

      httpPost(`${unifiedEnvConfig.ADD_TOPIC}?client_id=${selectedClient.id}`, {
        topic_name: topicname,
        and_contains: and_contains,
        or_contains: or_contains,
        not_contains: not_contains,
        type: 1,
        page_ids: pageIds,
        hashtags: hashtags,
        category: category,
      })
        .then(({ status }) => {
          if (status === HTTP_CODES.CREATED) {
            setAddTopicStep(-1);
            localStorage.clear();
            dispatch(fetchSocialEntityDetails(selectedClient.id));
          }
        })
        .catch((e) => e)
        .finally(() => setEditData(null));
    } else {
      window.location.pathname = `${TOPICS}/${VERTICALS.V_SOCIAL}`;
    }
  };

  const renderPages = (pages) => {
    if (!pages) {
      return null;
    }
    return pages.map((pageGroup) => {
      if (!pageGroup) {
        return null;
      }
      let filteredPages = pageGroup.pages || [];
      filteredPages = filteredPages.filter((fp) => !fp.is_unauthorized);
      if (!filteredPages.length) {
        return null;
      }

      return (
        <div className="pageGroupWrap">
          <div className="pageGroupHeader">
            <span className="pgName">{pageGroup.name}</span>
            {pageGroup.email && (
              <span className="pgEmail">({pageGroup.email})</span>
            )}
          </div>
          <div className="pageGoupListing">
            {filteredPages.map((page) => {
              if (!page) {
                return null;
              }
              const { name, type, id } = page;

              return (
                <div key={name} className="accountTile">
                  <div className="accDetails">
                    <div className="adLeft">
                      <SocialIcon type={type} />
                      <span>{name}</span>
                    </div>
                    <div className="adRight">
                      <label className="inputWrap">
                        <input
                          type="checkbox"
                          defaultChecked={pageIds.indexOf(id) !== -1}
                          value={id}
                          onChange={getCheckboxValue}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="accContainer authorizeContainer">
        <div className="fbLoginBtnWrap">
          <button
            className="fbLoginBtn"
            value="Login"
            onClick={authoriseAccount}
          >
            Authorize Facebook / Instagram Account
          </button>
        </div>
        <div className="accountTitleListingWrap">
          {isPagesLoading && <Loader />}
          {!isPagesLoading && pages.length ? (
            <>
              <div className="accountTitleListing">{renderPages(pages)}</div>
              <div>
                <div className="btnContainer hide">
                  <Button
                    label="Add Topic"
                    type="submit"
                    className="btn btnBlue"
                    onClick={addTopic}
                    disabled={isTopicAdditionIsProgress}
                  />
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}
